import urls from './urls'
import Service from '@/utils/fetch'

/**
 * 
 */


export function _getUnitType(data) {
    return Service({
        url:urls.getUnitType,
        data
    })
}

export function _getProvinceOrCity(data) {
    return Service({
        url:urls.getProvinceOrCity,
        data
    })
}

export function _getUnitList(data) {
    return Service({
        url:urls.getUnitList,
        data
    })
}

export function _unitCreateEditDelete(data) {
    return Service({
        url:urls.unitCreateEditDelete,
        data
    })
}

export function _getUnitDetailWithId(data) {
    return Service({
        url:urls.getUnitDetailWithId,
        data
    })
}

export function _getUnitStatisticsWithId(data) {
    return Service({
        url:urls.getUnitStatisticsWithId,
        data
    })
}

export function _getHallList(data) {
    return Service({
        url:urls.getHallList,
        data
    })
}

export function _getCeremonyList(data) {
    return Service({
        url:urls.getCeremonyList,
        data
    })
}

export function _getAccountList(data) {
    return Service({
        url:urls.getAccountList,
        data
    })
}

export function _hallCreateOrEdit(data) {
    return Service({
        url:urls.hallCreateOrEdit,
        data
    })
}

export function _deleteHall(data) {
    return Service({
        url:urls.deleteHall,
        data
    })
}

export function _getTemplateAllList(data) {
    return Service({
        url:urls.getTemplateAllList,
        data
    })
}

export function _templateCreateOrEdit(data) {
    return Service({
        url:urls.templateCreateOrEdit,
        data
    })
}

export function _deleteTemplate(data) {
    return Service({
        url:urls.deleteTemplate,
        data
    })
}





// WEBPACK FOOTER //
// ./src/api/Unit/index.js